import { AgentsButton } from '@mint-lib/ai-chat/components';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@mint-lib/tw-components';

import AgenticAiAgentsList from './AgenticAiAgentsList.jsx';

const AgenticAiAgentsButton = () => {
  return (
    <div className="z-overlay flex flex-row items-center justify-start gap-2">
      <Popover modal>
        <PopoverTrigger asChild>
          <AgentsButton aria-label="agentic-list-button" />
        </PopoverTrigger>

        <PopoverContent
          side="bottom"
          sideOffset={5}
          align="start"
          className="relative mt-2 h-full w-88 [scrollbar-width:none] overflow-y-auto scroll-auto rounded-lg data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:animate-in data-[state=open]:fade-in-0"
        >
          <AgenticAiAgentsList />
        </PopoverContent>
      </Popover>
    </div>
  );
};

export default AgenticAiAgentsButton;
